module.exports = __webpack_public_path__ + "img/s00174.36ccb654.png";